import { useCallback } from "react";
import { UserAuth } from "../context/AuthContext";
import requestHandler from "../utils/requestHandler";

export function useApi() {
    const { user } = UserAuth();
    const authToken = user?.accessToken ? `Bearer ${user.accessToken}` : null;
    
    const api = useCallback(
        (path, method = "GET", body) => requestHandler(path, method, authToken, body),
        [authToken]
    );
    
    return { api, authToken };
}
